     var overlayDiv = $('.t4s-close-overlay');
      var htmlElement = $('html');

        $(document).on('click', '.dev_show_dropdown', function() {
          // Close any open dropdowns by removing the 'show' and 'active' class from all others
          $('.dev_show_dropdown').not(this).removeClass('show');
          $('.dev_show_dropdown').not(this).each(function() {
            $(document).find('.section_' + $(this).data('filter-handle')).removeClass('active');
          });

          // Toggle the clicked dropdown
          var section = $(document).find('.section_' + $(this).data('filter-handle'));
          if ($(this).hasClass('show')) {
            $(this).removeClass('show');
            section.removeClass('active');
          } else {
            $(this).addClass('show');
            section.addClass('active');
          }

           
          
        });

  //   $(document).on('click', '.dropdown-content', function(event) {


  //     var parentDropdown = $(this).siblings('.dev_show_dropdown');
  //     console.log("Hello::",parentDropdown)
  //     console.log("Hello::",this)

  //     // Check if the dropdown is active, then remove the active and show classes
  //     if (parentDropdown.hasClass('show')) {
  //         parentDropdown.removeClass('show');
  //         $(document).find('.section_' + parentDropdown.data('filter-handle')).removeClass('active');
  //     }
  // });

    $(document).on('click', '.dropdown-content a', function(event) {
      // Prevent default action for disabled links
      if ($(this).hasClass('is--disabled')) {
          event.preventDefault();
          console.log("This link is disabled.");
          return; // Exit the function if the link is disabled
      }

      var parentDropdown = $(this).closest('.dropdown-content').siblings('.dev_show_dropdown');
      console.log("Hello::", parentDropdown);
      console.log("Clicked link::", this);

      // Check if the dropdown is active, then remove the active and show classes
      if (parentDropdown.hasClass('show')) {
          parentDropdown.removeClass('show');
          $(document).find('.section_' + parentDropdown.data('filter-handle')).removeClass('active');
      }

  });

  function toggleModal() {
    console.log("777777777");
      // Close sorting modal if it is open
      $(document).find('.sorting-modal').removeClass('active-sort-modal');
      $(document).find('#sorting-svg svg').removeClass('active-svg');




      // Toggle main modal
      $(document).find('#modal-filter-custom').toggleClass('active-modal');
      $(document).find('#filter-svg svg').toggleClass('active-svg');
      overlayDiv.addClass('is--visible');
      htmlElement.addClass('t4s-lock-scroll');

    $('.dev_show_dropdown:first').addClass('show');
    $('.filter-item .dropdown-content:first').addClass('active');

  }

  function stickySorting() {
    $(document).find('.sticky-sorting-modal').toggleClass('active-sort-modal');
    overlayDiv.addClass('is--visible');
    htmlElement.addClass('t4s-lock-scroll');
  }

  function closeModal() {
      $(document).find('#modal-filter-custom').removeClass('active-modal');
    $(document).find('#filter-svg svg').removeClass('active-svg');

         overlayDiv.removeClass('is--visible');
      htmlElement.removeClass('t4s-lock-scroll');

    $('.dev_show_dropdown:not(:first)').removeClass('show');
    $('.filter-item .dropdown-content:not(:first)').removeClass('active');
  }


    function applyFilter() {
      // updateApplyFilterButton();
      closeModal();
      console.log("111:::");
      console.log("1111:::",$(document).find('#active_filter'));
      $(document).find('#active_filter').addClass('active-filter');
  }

  function toggleSortingModal() {
      // Close main modal if it is open
      $(document).find('#modal-filter-custom').removeClass('active-modal');
      $(document).find('#filter-svg svg').removeClass('active-svg');

      // Toggle sorting modal
      $(document).find('.sorting-modal').toggleClass('active-sort-modal');
      $(document).find('#sorting-svg svg').toggleClass('active-svg');

  }

  function closeSortingModal() {
      $(document).find('.sorting-modal').removeClass('active-sort-modal');
    $(document).find('#sorting-svg svg').removeClass('active-svg');
  }

  function closeStickySortingModal() {
    $(document).find('.sticky-sorting-modal').removeClass('active-sort-modal');
    overlayDiv.removeClass('is--visible');
    htmlElement.removeClass('t4s-lock-scroll');
  }